import { render } from "./Qrcodetaoqu.vue?vue&type=template&id=e2fa1890&scoped=true&ts=true"
import script from "./Qrcodetaoqu.vue?vue&type=script&lang=ts"
export * from "./Qrcodetaoqu.vue?vue&type=script&lang=ts"

import "./Qrcodetaoqu.vue?vue&type=style&index=0&id=e2fa1890&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2fa1890"]])

export default __exports__